import type { EntityPageStore } from '../../types/entity-page-store';
import { useEntityPageStore } from '../use-entity-page-store/use-entity-page-store';

/**
 * TODO: remove this "fake" hook once every place is replaced with useEntityPageStore
 * @deprecated use useEntityPageStore instead
 */
export const usePageContext = (): EntityPageStore => {
  return useEntityPageStore((store) => store);
};
